//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class StimulusControllers
{
	public static branchResolver: string = `branch-resolver`;
	public static branchOutcomeArrival: string = `branch-outcome-arrival`;
	public static body: string = `body`;
	public static destinationDetail: string = `destination-detail`;
	public static destinationExplore: string = `destination-explore`;
	public static touristCardRedirect: string = `tourist-card-redirect`;
	public static destinationSights: string = `destination-sights`;
	public static contentShare: string = `content-share`;
	public static iframeFullScreenButton: string = `iframe-full-screen-button`;
	public static poiDetail: string = `poi-detail`;
	public static poiVideo: string = `poi-video`;
	public static responsiveImageHeader: string = `responsive-image-header`;
	public static persistentAudioPlayer: string = `persistent-audio-player`;
	public static gpsTriggering: string = `gps-triggering`;
	public static smartGuideMapPreview: string = `smartguide-map-preview`;
	public static smartGuidePermanentMap: string = `smart-guide-permanent-map`;
	public static smartGuideTourTray: string = `smartguide-tour-tray`;
	public static thumbnailDistance: string = `thumbnail-distance`;
	public static nativeAppInstallDialog: string = `native-app-install-dialog`;
	public static analyticsConsent: string = `analytics-consent`;
	public static webIntegrationNavigationGuard: string = `web-integration-navigation-guard`;
}
